import React, { ReactNode } from 'react';
import { Alert, Typography } from '@mui/material';
import { EditRestrictionReason } from 'modules/aftermarket';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

interface Props {
  reason?: EditRestrictionReason;
}

export const EditRestrictionReasonMessage = ({ reason }: Props) => {
  const editRestrictionReasons: Record<EditRestrictionReason, ReactNode> = {
    [EditRestrictionReason.SHARED_PRODUCT]: 'This product has been shared with you. You cannot edit it.',
    [EditRestrictionReason.USER_ROLE]: 'Your user role does not permit editing this product in Aftermarket Management.',
    [EditRestrictionReason.LICENSE_TYPE]:
      'Your license type does not permit editing this product in Aftermarket Management.',
  };

  return (
    <RenderWithCondition condition={!!reason && !!editRestrictionReasons[reason]}>
      <Alert variant="standard" color="warning" elevation={2}>
        <Typography>{editRestrictionReasons[reason!]}</Typography>
      </Alert>
    </RenderWithCondition>
  );
};
